import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import { Link } from "react-router-dom"; 
import MUILink  from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

function Footer({ light, footerAbs, data }) {
  const { size } = typography;
  return (
    <MDBox position={footerAbs ? "absolute" : "static"} width="100%" bottom={0} py={4}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()}, created by{" "}
            <a style={{margin:"0 3px"}} href="https://www.digitalpartner.dz" rel="nofollow">
             Digital-Partner
            </a>   All rights reserved
          </MDBox>
          <MDBox
            component="ul"
            sx={({ breakpoints }) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              listStyle: "none",
              mt: 3,
              mb: 0,
              p: 0,

              [breakpoints.up("lg")]: {
                mt: 0,
              },
            })}
          >
            <MDBox component="li" pr={2} lineHeight={1}>
              <MUILink href={data?.facebook} target="_blank">
                <Icon fontSize="medium" >facebook</Icon>
              </MUILink>
            </MDBox>
            <MDBox component="li" px={2} lineHeight={1}>
              <MUILink href={data?.twitter} target="_blank">
              <TwitterIcon fontSize="medium" />
              </MUILink>
            </MDBox>
            <MDBox component="li" px={2} lineHeight={1}>
              <MUILink  sx={{cursor:"pointer"}} href={data?.instagram} target="_blank">
                <InstagramIcon fontSize="medium"/>
              </MUILink>
            </MDBox>
            <MDBox component="li" pl={2} lineHeight={1}>
              <MUILink component={Link} to="/">      
                <Icon fontSize="medium">home</Icon>
              </MUILink>
            </MDBox>
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
  footerAbs : false
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
